@if (cardInfo(); as cardInfo) {
  <crm-activity-card [activity]="activity()" [icon]="icon()" [crmObjectIdentifier]="associatedObject()">
    <span activity-title>
      @if (cardInfo.title; as title) {
        <span>
          <strong>{{ title.typeWithVerb | translate }}</strong>
          {{ title.preposition | translate }}
        </span>
        @if (fullName()) {
          <span> {{ fullName() }}</span>
        }
      } @else {
        {{ 'ACTIVITY.UNKNOWN_TITLE' | translate }}
      }
      @if (showPrimaryAssociation()) {
        @if (primaryAssociation(); as primaryAssociation) {
          {{ 'OBJECT_TYPES.FOR_LABEL' | translate }}
          <a [routerLink]="primaryAssociationLink()">{{ primaryAssociation.name }}</a>
        }
      }
    </span>

    <div activity-preview>
      <crm-activity-rich-text [richText]="cardInfo.body"></crm-activity-rich-text>
      @if (callRecordingSource$ | async; as callUrl) {
        <audio class="activity-data-call-recording" preload="metadata" controls src="{{ callUrl }}">
          {{ 'ACTIVITY.AUDIO_PLAYBACK_ERROR' | translate }}
        </audio>
      }
      <crm-activity-data-grid [dataItems]="activityDataItems()"></crm-activity-data-grid>
    </div>
  </crm-activity-card>
}
